import React, {
    useState
} from 'react'
// AppBar
import {
  Avatar,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem
} from '@material-ui/core'
import tim from '../assets/yuting_.ico'
import MenuIcon from '@material-ui/icons/Menu';
// icons
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import BuildIcon from '@material-ui/icons/Build';
// style
import { makeStyles } from '@material-ui/core/styles';
// route
import { useHistory } from 'react-router';


//
// IMPORT ZONE
//

const useStyles = makeStyles((theme) => ({
    appBar: {
        background: '#7EAED9'
    }
}))

function Header() {
    const classes = useStyles()
    // menu 
    const [ menuEl, setMenuEl ] = useState(null);
    const history = useHistory();
    const handleMenuOnClick = (path) => {
        history.push(`/${path}`)
        setMenuEl(null)
    }
    return (
    <>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
           <IconButton 
            edge="start" 
            color="inherit" 
            aria-label="menu"
            onClick={(event) => setMenuEl(event.currentTarget)}
            >
             <MenuIcon />
           </IconButton>
           <Avatar src={tim}/>
           &nbsp;
           <h2
            style={{ cursor: 'pointer'}}
            onClick={() => handleMenuOnClick('')}>
             Yuting Object Detection
           </h2>
         </Toolbar>
     </AppBar>
     {/* Menu */}
     <Menu
       anchorEl={menuEl}
       getContentAnchorEl={null}
       anchorOrigin={{ vertical: "bottom" }}
       keepMounted
       open={Boolean(menuEl)}
       onClose={() => setMenuEl(null)}
     >
      <MenuItem onClick={() => handleMenuOnClick('object-detection')}> <ImageSearchIcon />&nbsp;看看美美的世界</MenuItem>
      <MenuItem onClick={() => handleMenuOnClick('object-detection-with-img')}> <AddPhotoAlternateIcon/>&nbsp;傳張照片吧</MenuItem>
      <MenuItem onClick={() => handleMenuOnClick('settings')}> <BuildIcon/>&nbsp;設定一下唷唷</MenuItem>
    </Menu>
    </>
    )
}

export default Header
